module.exports = __webpack_public_path__ + "static/banner-tv-pingentes-letras-c0208975be5e8fa832a7c5b204c38b15.jpg";